// extracted by mini-css-extract-plugin
module.exports = {"logo":"src-views-dashboard-sub-home-stock-list-styles__logo--Z7k4W"};